import { MEmailBlock } from '../../mdl/m-template';
import { UITextInput } from '../../ui/component/input';
import { UILabeled } from '../../ui/component/labeled';
import { UISelect } from '../../ui/component/select';
import { UIExclusiveToggles, UIRadio } from '../../ui/component/toggle';
import { $el } from '../../ui/elements';
import { $on } from '../../y/events';
import { $form } from '../../y/form';
import { EDBlockSpec, EDBlock } from '../block';
import { EDBlockContainer } from '../editor';
import { EDI18NInput } from '../input';
import { EDEmailEditor } from './editor';

export const ed_email_button_block: EDBlockSpec<MEmailBlock, EDEmailEditor> = {
    key: 'button',
    editor_block: class extends EDBlock<EDEmailEditor> {
        constructor(container: EDBlockContainer<EDEmailEditor>) {
            const text = new EDI18NInput({ placeholder: 'Text', fields: container.editor.fields, classes: 'r-button' });
            const link_type_values = [{ key: 'url', title: 'URL' }, { key: 'link', title: 'Predefined' }];
            const link_type = new UIExclusiveToggles(link_type_values, v => new UIRadio(v), { classes: 'l-toggle-row' });

            const url = new UITextInput({ autofocus: true, kind: 'k-subtle' });
            const link = new UISelect(container.editor.link_values, { kind: 'k-subtle' });

            const properties = $el.DIV('l-form', [
                link_type,
                new UILabeled(url, { above: 'URL' }),
                new UILabeled(link, { above: 'Link' }),
            ]);

            const form = $form({ link_type, url, link, text });

            $on(link_type, 'value', v => {
                url.ui_show(undefined, v == 'url');
                link.ui_show(undefined, v == 'link');
            });

            super(form, container, 'Button', properties);

            this.ui_add($el.DIV('tl-email-button', text));
        }
    },
};
